import { render, staticRenderFns } from "./studies.vue?vue&type=template&id=ef19ec96&scoped=true&"
import script from "./studies.vue?vue&type=script&lang=js&"
export * from "./studies.vue?vue&type=script&lang=js&"
import style0 from "./studies.vue?vue&type=style&index=0&id=ef19ec96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef19ec96",
  null
  
)

component.options.__file = "studies.vue"
export default component.exports